//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model

import blazern.lexisoup.graphql.model.adapter.LexicalItemsFromPanLexQuery_ResponseAdapter
import blazern.lexisoup.graphql.model.adapter.LexicalItemsFromPanLexQuery_VariablesAdapter
import blazern.lexisoup.graphql.model.fragment.TranslationsSetFields
import blazern.lexisoup.graphql.model.selections.LexicalItemsFromPanLexQuerySelections
import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.ExecutableDefinition
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import kotlin.Boolean
import kotlin.String
import kotlin.collections.List
import blazern.lexisoup.graphql.model.type.Query as CompiledQuery

public data class LexicalItemsFromPanLexQuery(
  public val query: String,
  public val langFromIso3: String,
  public val langToIso3: String,
) : Query<LexicalItemsFromPanLexQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    LexicalItemsFromPanLexQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = ADAPTER

  override fun rootField(): CompiledField = ROOT_FIELD

  @ApolloAdaptableWith(LexicalItemsFromPanLexQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val panlex: List<Panlex>,
  ) : Query.Data

  public data class Panlex(
    public val __typename: String,
    /**
     * Synthetic field for inline fragment on WordTranslations
     */
    public val onWordTranslations: OnWordTranslations?,
    /**
     * Synthetic field for inline fragment on Synonyms
     */
    public val onSynonyms: OnSynonyms?,
  )

  public data class OnWordTranslations(
    public val source: String,
    public val translationsSet: TranslationsSet,
  )

  public data class TranslationsSet(
    public val __typename: String,
    /**
     * Synthetic field for 'TranslationsSetFields'
     */
    public val translationsSetFields: TranslationsSetFields,
  )

  public data class OnSynonyms(
    public val source: String,
    public val translationsSet: TranslationsSet1,
  )

  public data class TranslationsSet1(
    public val __typename: String,
    /**
     * Synthetic field for 'TranslationsSetFields'
     */
    public val translationsSetFields: TranslationsSetFields,
  )

  public companion object : ExecutableDefinition<Data> {
    override val ADAPTER: Adapter<Data> = LexicalItemsFromPanLexQuery_ResponseAdapter.Data.obj()

    override val ROOT_FIELD: CompiledField = CompiledField.Builder(
          name = "data",
          type = CompiledQuery.type
        )
        .selections(selections = LexicalItemsFromPanLexQuerySelections.__root)
        .build()

    public const val OPERATION_ID: String =
        "47ba5c340bc83750ed680b955cc2711f3b5a5597cd60e31e839ff062db9b2aaf"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query LexicalItemsFromPanLexQuery($query: String!, $langFromIso3: String!, $langToIso3: String!) {
     *   panlex(query: $query, langFromIso3: $langFromIso3, langToIso3: $langToIso3) {
     *     __typename
     *     ... on WordTranslations {
     *       source
     *       translationsSet {
     *         __typename
     *         ...TranslationsSetFields
     *       }
     *     }
     *     ... on Synonyms {
     *       source
     *       translationsSet {
     *         __typename
     *         ...TranslationsSetFields
     *       }
     *     }
     *   }
     * }
     *
     * fragment SentenceFields on Sentence {
     *   text
     *   langIso3
     *   source
     * }
     *
     * fragment TranslationsSetFields on TranslationsSet {
     *   original {
     *     __typename
     *     ...SentenceFields
     *   }
     *   translations {
     *     __typename
     *     ...SentenceFields
     *   }
     *   translationsQualities
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query LexicalItemsFromPanLexQuery(${'$'}query: String!, ${'$'}langFromIso3: String!, ${'$'}langToIso3: String!) { panlex(query: ${'$'}query, langFromIso3: ${'$'}langFromIso3, langToIso3: ${'$'}langToIso3) { __typename ... on WordTranslations { source translationsSet { __typename ...TranslationsSetFields } } ... on Synonyms { source translationsSet { __typename ...TranslationsSetFields } } } }  fragment SentenceFields on Sentence { text langIso3 source }  fragment TranslationsSetFields on TranslationsSet { original { __typename ...SentenceFields } translations { __typename ...SentenceFields } translationsQualities }"

    public const val OPERATION_NAME: String = "LexicalItemsFromPanLexQuery"
  }
}
